// @flow

export const ValidationMsg = {
    email: {
        required: "Email is required.",
        format: "Email format is invalid."
    },
    password: {
        required: "Password is required.",
        complex:
            "Password must be a minimum of 7 characters and include a mix of numbers, lower and uppercase characters.",
        match: "Passwords don't match."
    },
    name: {
        required: "Field is required.",
        format: "Field has invalid characters"
    },
    postcode: {
        required: "Please select a postcode from the dropdown."
    },
    istrade: {},
    isOptIn: {},
    accountnumber: {
        format: "Invalid trade account number entered."
    }
};
